<template>
    <a href="#" class="highlights-box" data-highlight="1">

        <picture>
            <source media="(max-width: 767px)" srcset="@/assets/img/highlightsBg.jpg">
            <source media="(max-width: 1023px)" srcset="@/assets/img/highlightsBg.jpg">
            <img src="@/assets/img/highlightsBg.jpg" class="img-absolute" alt="">
        </picture>

        <span class="img-layer"></span>

        <div class="top">
            <h2 class="noto-semibold ttl">Performance Highlights 1 Dealer nal Dealer Personal Dealer</h2>
            <div class="icon">
                <img src="@/assets/img/highlights1.png" alt="" class="img-absolute">
                <img src="@/assets/img/highlights2.png" alt="" class="img-absolute">
            </div>
        </div>

        <div class="txt">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur iste nihil veritatis omnis officia molestiae eligendi, nesciunt explicabo rem alias quisquam corporis quia facere voluptatem repudiandae, accusamus nobis voluptatum eos!
        </div>

        <div class="bottom">
            <div class="line-wrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="726.5" height="0.5" viewBox="0 0 726.5 0.5">
                <line id="Line_27" data-name="Line 27" x2="726" transform="translate(0.25 0.25)" fill="none" stroke="#bcbec0" stroke-linecap="round" stroke-width="0.5" stroke-dasharray="10"/>
                </svg>
            </div>


            <div class="whiteRed-btn">
                <span class="noto-semibold">Get It Today</span>
            </div>
        </div>

    </a>
</template>

<script>
export default {
    
}
</script>